/* eslint-disable no-restricted-imports */
import { Card, CardContent, Divider, Grid, Typography } from '@material-ui/core';

import { FormatMoney } from 'components';
import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function FinancialSummaryCard({
  totalCost,
  totalSell,
  profit,
  margin,
  title = 'Resumo Financeiro',
}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant='subtitle1' className={classes.title}>
          {title}
        </Typography>
        <Divider className={classes.divider} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant='body2' color='textSecondary'>
              Total Custo
            </Typography>
            <Typography variant='h6'>
              <FormatMoney>{totalCost}</FormatMoney>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant='body2' color='textSecondary'>
              Total Venda
            </Typography>
            <Typography variant='h6' className={classes.sellPrice}>
              <FormatMoney>{totalSell}</FormatMoney>
            </Typography>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant='body2' color='textSecondary'>
              Lucro
            </Typography>
            <Typography variant='h6' className={classes.profitValue}>
              <FormatMoney>{profit}</FormatMoney>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant='body2' color='textSecondary'>
              Margem
            </Typography>
            <Typography variant='h6' className={classes.profitValue}>
              {margin}%
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

FinancialSummaryCard.propTypes = {
  totalCost: PropTypes.number.isRequired,
  totalSell: PropTypes.number.isRequired,
  profit: PropTypes.number.isRequired,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string,
};
